import React, { FC, useState, useEffect } from 'react';
import * as S from './styled';

export const Timer: FC = props => {
	const [seconds, setSeconds] = useState(900);

	useEffect(() => {
		const interval = setInterval(() => {
			if (seconds > 0) {
				setSeconds(seconds => seconds - 1);
			}
		}, 1000);
		return () => clearInterval(interval);
	}, [seconds]);

	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;

	return (
		<S.Timer>
			{minutes}:{remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}
		</S.Timer>
	);
};
